import React from "react";
import AlphaherdAccordionCard from "../../component/shared/card/alphaherd.accordionCard";
import AlphaherdSectionContentCard from "../../component/shared/card/alphaherd.sectionContentCard";
import { allocationData } from "./data";
const AlphaherdAllocationSection = () => {
  return (
    <section className="alpha_allocation_section">
      <div className="container">
        <div className="section_wrapper">
          <div className="row">
            {allocationData.map((d, i) => (
              <>
                <div className="col-md-6 section_content">
                  <AlphaherdSectionContentCard
                    subTitle={d.subTitle}
                    title={d.title}
                    description={d.description}
                  />
                </div>
                <div className="col-md-6 section_accordion">
                  <AlphaherdAccordionCard accordions={d.accordions} />
                </div>
              </>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AlphaherdAllocationSection;
